import React from "react";
import {useTranslation} from "react-i18next";
import {Dialog, DialogTitle} from "@material-ui/core/";
import DialogContent from "@material-ui/core/DialogContent";
import {makeStyles} from "@material-ui/core/styles";
import {useNavigate} from "react-router-dom";


// Import Pages
import AppCredentialProcess from '../appCredentialProcess/AppCredentialProcess';
import ChooseApplication from '../chooseApplication/ChooseApplication';

// Import Css
import "./AppCredentialModal.css";

const useStyles = makeStyles((theme) => ({
    bottomSection: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },
    button: {
        border: "none",
        borderRadius: "5px",
        width: 100,
        height: 35,
        float: "right",
        "&:focus": {
            outline: "none",
        },
    },
    submit: {
        color: "white",
        marginLeft: 15,
        backgroundColor: "#079063",
        cursor: "pointer",
    }
}));

const AppCredentialModal = ({
                                selectedApp,
                                setSelectedApp,
                                appCredentialId,
                                setApplication,
                                changeApp,
                                setOpen,
                                open,
                                cancel,
                                afterSave,
                            }) => {
    const history = useNavigate();
    const classes = useStyles();
    const {t} = useTranslation();
    const label = "CONTENT.APP-CREDENTIAL."

    return (
        <Dialog
            id="autom-addNew-modal"
            data-test="autom-add-new"
            open={true}
            PaperProps={{
                style: {
                    minWidth: 750,
                    padding: "8px 24px 8px 24px"
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                <div id="about-title" className="head-title">
                    <div className="app-container" style={{float: 'right', marginBottom: 0}}>
                        <div
                            className={`app-icon app-${selectedApp.name.replace(' ', '-').toLowerCase()}`}
                            onClick={() => changeApp()}
                        >
                            <img src={selectedApp.image_path} alt={selectedApp.name}/>
                        </div>
                        {/* <span>
                        {selectedApp.name}
                    </span> */}
                    </div>
                    <span className="new-credential-title">{t(label + "NEW-CREDENTIAL")}</span>
                </div>
            </DialogTitle>
            <DialogContent>
                <AppCredentialProcess setApplication={setApplication} selectedApp={selectedApp}
                                      setSelectedApp={setSelectedApp} cancel={cancel} showCancelButton={true}
                                      setRefreshCredentials={afterSave} appCredentialId={appCredentialId}/>
            </DialogContent>
            {open && <ChooseApplication setApplication={setApplication} setOpen={setOpen}/>}

        </Dialog>
    );
};

export default AppCredentialModal;
